<h2 mat-dialog-title>Manual Load</h2>

<mat-dialog-content *ngIf="!complete && !loading">
  <p>
    Are you sure you want to manually load TPM Checklists for
    <strong>{{data.objectDescription || data.objectID}}</strong>?
  </p>
</mat-dialog-content>

<mat-dialog-actions *ngIf="!complete && !loading" align="end">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-raised-button color="primary" (click)="confirmLoad()">Yes</button>
</mat-dialog-actions>

<mat-dialog-content *ngIf="loading">
  <p>Loading checklists...</p>
</mat-dialog-content>

<mat-dialog-content *ngIf="complete">
  <div *ngIf="message">
    <p><strong>{{message}}</strong></p>
  </div>

  <div *ngIf="shiftDate || shift">
    <p>Shift Date: {{shiftDate}}</p>
    <p>Shift: {{shift}}</p>
  </div>

  <div *ngIf="loadedChecklists.length > 0; else noLoadedChecklist">
    <p>Loaded Checklists:</p>
    <ul>
      <li *ngFor="let item of loadedChecklists">
        {{item.task_type}}
      </li>
    </ul>
  </div>

  <ng-template #noLoadedChecklist>
    <p>No checklists were loaded.</p>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions *ngIf="complete" align="end">
  <button mat-raised-button color="primary" (click)="close(true)">Close</button>
</mat-dialog-actions>